<section
  fxLayout="column"
  fxLayoutAlign=""
  class="page-container default-padding"
>
  <div>
    <a
      fxLayout="row"
      fxLayoutAlign="start center"
      class="mat-title no-margin default-ptb no-decor"
      [routerLink]="'/dashboard'"
    >
      <mat-icon>arrow_back</mat-icon> {{ "return to all resumes" | titlecase }}
    </a>
  </div>

  <div fxLayoutAlign="space-between center">
    <h3>
      {{ getUserFullName() }} |
      <span class="mat-title">Resumes</span>
    </h3>
    <a
      mat-raised-button
      color="primary"
      [routerLink]="'/resume-portal/create-resume'"
    >
      <mat-icon>add</mat-icon>Create New
    </a>
  </div>
  <mat-progress-bar
    *ngIf="loadingUserResumes$ | async"
    mode="indeterminate"
  ></mat-progress-bar>
  <mat-divider></mat-divider>

  <div class="spacer"></div>
  <p></p>
  <section fxLayout="row wrap">
    <section
      *ngFor="let props of userResumes"
      fxFlex="50"
      class="mtb"
      fxLayout="row"
    >
      <section fxFill fxLayout="row" class="no-padding">
        <mat-card fxFlex="70" class="no-padding mat-elevation-z5">
          <section fxFlex="65" class="default-padding">
            <div>
              <div class="normal-font no-margin bold">
                {{ props.resume.given_name | titlecase }}
                {{ props.resume.family_name | titlecase }}
              </div>
              <div class="mat-caption small-font">
                {{ props.resume.wanted_job_title }}
              </div>
            </div>
            <div class="spacer"></div>
            <div>
              <div class="meduim-font no-margin bold">Profile</div>
              <p class="small-font">{{ props.resume.professional_summary }}</p>
            </div>
            <div class="spacer"></div>
            <div>
              <div class="meduim-font no-margin bold">Employment History</div>
              <div *ngFor="let employment of props.resume.employments">
                <div class="spacer"></div>
                <div>
                  <div class="small-font no-margin bold">
                    {{ employment.job_title | titlecase }},
                    {{ employment.employer | titlecase }}
                  </div>
                  <div class="small-font">
                    {{ employment.start_date }} - {{ employment.end_date }}
                  </div>
                  <p
                    class="no-margin small-font"
                    *ngFor="let description of employment.descriptions"
                  >
                    - {{ description.substring(1, 100) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="spacer"></div>
            <div>
              <div class="meduim-font no-margin bold">Education</div>
              <div *ngFor="let edu of props.resume.educations">
                <div class="spacer"></div>
                <div>
                  <div class="small-font no-margin bold">
                    {{ edu.degree | titlecase }}, {{ edu.school | titlecase }},
                    {{ edu.city | titlecase }}
                  </div>
                  <div class="small-font">
                    {{ edu.start_date }} - {{ edu.end_date }}
                  </div>
                  <p
                    class="no-margin small-font"
                    *ngFor="let edu_description of edu.descriptions"
                  >
                    - {{ edu_description.substring(1, 100) }}
                  </p>
                </div>
              </div>
            </div>

            <div class="spacer"></div>
            <div>
              <div class="meduim-font no-margin bold">Certificates</div>
              <div *ngFor="let cert of props.resume.certificates">
                <p class="no-margin small-font">
                  - {{ cert.substring(1, 100) }}
                </p>
              </div>
            </div>

            <div class="spacer"></div>
            <div>
              <div class="meduim-font no-margin bold">References</div>
              <p class="no-margin small-font">
                Reference available upon request
              </p>
            </div>
          </section>

          <section fxFlex="35" class="resume-side-bg default-padding">
            <div class="mat-title no-margin">Details</div>
            <div class="small-font">{{ props.resume.phone_number }}</div>
            <div class="small-font">{{ props.resume.email }}</div>
            <div fxLayout="column">
              <label>Nationality</label>
              <label class="small-font">
                {{ props.resume.nationality | uppercase }}
              </label>
            </div>
            <div class="spacer"></div>
            <div>
              <label>Links</label>
              <div class="small-font" *ngFor="let link of props.resume.links">
                <a class="color" [href]="link.url">{{ link.label }}</a>
              </div>
            </div>
            <div class="spacer"></div>
            <div>
              <label>SKILLS</label>
              <div *ngFor="let skill of props.resume.skills">
                <div class="small-font">{{ skill.skill | titlecase }}</div>
                <mat-progress-bar
                  mode="determinate"
                  [value]="skill.expertise"
                  [color]="'light'"
                ></mat-progress-bar>
              </div>
            </div>
          </section>
        </mat-card>
        <section fxFlex>
          <div
            fxLayout="column"
            fxFill
            class="default-padding"
            fxLayoutAlign="center start"
          >
            <div class="bold normal-font">{{ props.name | titlecase }}</div>
            <div>{{ props.last_updated }}</div>
            <mat-card-actions
              fxLayout="column"
              class="full no-margin"
              fxLayoutAlign="start"
            >
              <button
                mat-button
                color="primary"
                fxLayoutAlign="start"
                class="full no-margin"
              >
                <mat-icon>create</mat-icon>Edit
              </button>
              <button
                mat-button
                color="primary"
                fxLayoutAlign="start"
                class="full no-margin"
              >
                <mat-icon>content_copy</mat-icon>Make a Copy
              </button>
              <button
                mat-button
                color="primary"
                fxLayoutAlign="start"
                class="full no-margin"
              >
                <mat-icon>file_download</mat-icon>Download PDF
              </button>
              <button
                mat-button
                color="warn"
                fxLayoutAlign="start"
                class="full no-margin"
              >
                <mat-icon>delete</mat-icon>delete
              </button>
            </mat-card-actions>
          </div>
        </section>
      </section>
    </section>
  </section>
</section>
